import { render, staticRenderFns } from "./LoadingDetails.vue?vue&type=template&id=748263a1&"
import script from "./LoadingDetails.vue?vue&type=script&lang=js&"
export * from "./LoadingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports